// src/services/maintenanceService.ts

// import { Auth } from 'aws-amplify';


import { BusinessProperty, Provider } from "../model/BusinessProperty";

export class MaintenanceService {


    static async getToken(): Promise<string> {
        //const session = await Auth.currentSession();
        //return session.getAccessToken().getJwtToken();
        return "";
    }

    static async fetchProperties(url: string, normalizePropertyData: any): Promise<BusinessProperty[]> {

        return fetch(url).then(async (response) => {

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            console.log('Data:', data);

            return normalizePropertyData(data)

        }).catch((error) => {
            console.log('Error:', error);
            throw new Error('Error parsing response');
        });
    }

    static async fetchProviders(url: string, normalizeProviderData: any): Promise<Provider[]> {

        return fetch(url).then(async (response) => {

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            console.log('Data:', data);

            return normalizeProviderData(data)

        }).catch((error) => {
            console.log('Error:', error);
            throw new Error('Error parsing response');
        });
    }

    static async updateProperty(url: string, key: string, value: string): Promise<void> {

        const urlPut = `${url}/${key}/${value}`;

        return await fetch(urlPut, {
            method: 'PUT',
            // mode: 'cors'
        }).then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
        }).catch((error) => {
            console.log('Error:', error);
            throw new Error('Network response was not ok');
        });
    }

    static async updateProviders(url: string, providers: any): Promise<void> {

        const urlPost = `${url}`;

        return await fetch(urlPost, {
            method: 'POST',
            // mode: 'no-cors',
            body: JSON.stringify(providers),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            console.log("response: ", response);
            
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
        }).catch((error) => {
            console.log('Error:', error);
            throw new Error('Network response was not ok');
        });
    }
}